import classNames from 'classnames';
import React from 'react';

import { bsClass, getClassSet, splitBsProps } from './utils/bootstrapUtils';

class ModalTitle extends React.Component {
  render() {
    const { className, ...props } = this.props;
    const [bsProps, elementProps] = splitBsProps(props);

    const classes = getClassSet(bsProps);

    return (
      <h4
        {...elementProps}
        className={classNames(className, classes)}
      />
    );
  }
}

export default bsClass('modal-title', ModalTitle);



// WEBPACK FOOTER //
// ./src/ModalTitle.js